import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'cuponesEC',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      ventas: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }
    }
  },
  computed: {
    reporte: function () {
      return '/reportes/resumen/liquidaciones-abierto?dsis=' + window.sssdi + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta 
    }
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  unmounted() {
    this.tbv.destroy();
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");


    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      'rowCallback': function (row, data, index) { },
    });
    $('.box').boxWidget();
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/resumen/liquidaciones-abierto', this.f_c)
        .then(response => {
          response.data.data.forEach(element => {
            for (let index = 8; index < 43; index++) {
              element[index] = this.num_to_many(element[index]);
            }

            this.tbv.row.add(element);
          });

          this.tbv.draw();
          this.loading = false;
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/resumenLiquidacionesAbierto/index.js